export default "__VITE_ASSET__BnIQt1qk__"